const strongReg = /^((?=.*[a-z])((?=.*[A-Z])|(?=.*\d)|(?=.*[!@#$%^&*?]))).+$/;

export default (password) => {
  let result;
  if (password.length === 0) {
    result = 'none';
  } else if (password.length > 0 && password.length < 6) {
    result = 'short';
  } else {
    if (strongReg.test(password)) {
      result = 'strong';
    } else {
      result = 'medium';
    }
  }
  return result;
};
